import React from "react";
import { LocaleProvider } from "@insightfulscience/smart-react/i18";
import WithConditions from "@insightfulscience/smart-react/hocs/WithConditions";
import { createAndRaise } from "@insightfulscience/shared-utils/fn/create-and-raise";
import ApplicationError from "@insightfulscience/smart-react/ApplicationError";
import pipe from "@insightfulscience/shared-utils/fn/pipe";

import createClient from "../../createClient";
import Page from "./Page";
import locales from "../../locales";
import checkPreviewMode from "../../utils/checkPreviewMode";
import { sanitize } from "../../utils/contentfulSanitizer";

const contentfulStandardFactory = ({ Layout, contentfulProps, pageProps }) => {
	const ContentfulStandardPage = ({ isPreview, post }) => {
		const { brandCode, resources = null } = pageProps;

		return (
			<Layout slug={post.slug}>
				<LocaleProvider resources={resources || locales[brandCode]}>
					<Page isPreview={isPreview} post={post} pageProps={pageProps} />
				</LocaleProvider>
			</Layout>
		);
	};

	ContentfulStandardPage.getInitialProps = async ({ req, query }) => {
		const { slug } = query;
		const isPreview = checkPreviewMode(req);
		const client = createClient(contentfulProps, isPreview);
		const fullSlug = Array.isArray(slug) ? slug.join("/") : slug;
		const items = await client.getEntries({
			content_type: "pageStandard",
			"fields.slug": fullSlug,
			include: 2,
		});

		if (items.total === 0) {
			return {
				post: null,
			};
		}

		return { isPreview, post: sanitize(items.items[0].fields) };
	};

	ContentfulStandardPage.propTypes = {
		...Page.propTypes,
	};

	ContentfulStandardPage.postConditions = [
		[({ post }) => post, createAndRaise(ApplicationError.NotFound)],
	];

	return pipe(ContentfulStandardPage, WithConditions);
};

export default contentfulStandardFactory;
